module.exports = __webpack_public_path__ + "82ad0a84b3652db7d8d5dff7e8b67f5f.png";